export const TERMS_OF_USE = `LevelUp Partner Content Access – Terms of Use

1. Purpose of the Portal
This portal provides authorized CSPs, Training Services Partners (TSPs), and Microsoft-approved partners access to Microsoft-aligned skilling content ("Content") to support partner-led training delivery for resellers and end customers.
The Content is intended solely for enablement and training delivery purposes, aligned to Microsoft's skilling and adoption objectives.

2. Eligibility & Access
Access to this portal is restricted to approved partner domains and is subject to review, approval, suspension, or revocation at any time by Technofocus and/or Microsoft.

3. Permitted Use of Content
Authorized partners may:
• Download and use the Content only to deliver Microsoft-aligned workshops, training sessions, or enablement programs
• Customize delivery without altering Microsoft product positioning, intent, or messaging
• Use the Content exclusively for non-commercial training delivery unless explicitly approved otherwise

4. Restricted Use
Partners must not:
• Resell, sublicense, or commercially monetize the Content
• Share Content with unauthorized third parties or public repositories
• Remove Microsoft, Technofocus, or partner attribution notices
• Modify Content in a way that misrepresents Microsoft solutions or guidance
• Use the Content outside the approved training scope

5. Content Ownership & IP
All Content remains the intellectual property of Microsoft and/or Technofocus.
Access to the Content does not transfer ownership or grant any IP rights beyond limited usage for approved training delivery.

6. Content Updates & Versioning
Content is subject to:
• Periodic updates, refreshes, or retirement
• Version control and change logs maintained by Technofocus
Partners are responsible for ensuring they use the latest approved version of the Content.

7. Reporting & Usage Insights
To support Microsoft's skilling impact measurement, partners agree to:
• Provide planned delivery schedules when requested
• Submit post-delivery attendance numbers for executed sessions
• Cooperate with reporting requirements related to trained learner metrics
Usage analytics may include:
• Content access and download activity
• Course usage trends
• Partner-reported delivery and attendance data
All reporting is used solely for skilling effectiveness and program governance.

8. Data Privacy
Any partner or learner data collected through this portal will be handled in accordance with:
• Technofocus Privacy Policy
• Microsoft data governance and compliance requirements
No personal data is shared outside the scope of program reporting.

9. Compliance & Audit
Microsoft and/or Technofocus reserve the right to:
• Review partner usage for compliance
• Request clarifications or corrective actions
• Revoke access in case of misuse or breach of these terms

10. Acceptance
By accessing this portal, you confirm that:
• You are authorized to act on behalf of your organization
• You understand and agree to these Terms of Use
• You will ensure compliance across your delivery teams`;
